import React from 'react';

interface SkeletonProps {
  variant?: 'rectangular' | 'text' | 'circular';
  width?: number | string;
  height?: number | string;
  borderRadius?: string | number;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  width,
  height,
  borderRadius,
  style,
}) => {
  const base: React.CSSProperties = {
    background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
    backgroundSize: '400% 100%',
    animation: 'skeleton-shimmer 1.4s infinite',
    display: 'block',
    width: width ?? '100%',
    height: height ?? (variant === 'text' ? 14 : 40),
    borderRadius:
      borderRadius !== undefined
        ? borderRadius
        : variant === 'circular'
          ? '50%'
          : variant === 'text'
            ? 4
            : 8,
    flexShrink: 0,
    ...style,
  };

  return (
    <>
      <style>{`
        @keyframes skeleton-shimmer {
          0% { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
      `}</style>
      <span style={base} />
    </>
  );
};

export default Skeleton;